import { ReportItem } from './report-items'

export enum RADashboardCardSize {
  Custom = 'custom_',
  ExtraSmall = 'XS',
  Small = 'S',
  Medium = 'M',
  Large = 'L',
  ExtraLarge = 'XL',
  Wide = 'W',
  ExtraWide = 'XW',
}

export enum RADashboardCardId {
  FactorLensRisk = 'factor_lens_risk',
  // Split-out Factor Lens cards
  FactorLensGridRisk = 'factor_risk',
  FactorWaterfallRisk = 'factor_waterfall_risk',
  FactorBreakdownRisk = 'factor_breakdown_risk',
  MetricsSummaryRisk = 'metrics_summary_risk',
  Point_DV01 = 'point_dv01',
  Point_Duration = 'point_duration',
  Point_Convexity = 'point_convexity',
  Point_YieldToMaturity = 'point_yieldmaturity',
  Point_TrailingRisk = 'trailing_risk',
  HoldingsContributionRisk = 'holdings_contribution_risk',
  HoldingsTopBottom = 'holdings_top_bottom',
  HoldingsRiskVisualization = 'holdings_risk_visualization',
  // Data point cards
  Point_SpreadDuration = 'point_spreadduration',
  Point_YearsToMaturity = 'point_yearstomaturity',
  Point_YieldToWorst = 'point_yieldtoworst',
  Point_CouponRate = 'point_couponrate',
  Point_DividendYield = 'point_dividendyield',
  Point_AverageLife = 'point_averagelife',
  Point_Beta = 'point_beta',
  Point_BookToPrice = 'point_booktoprice',
  Point_BookValue = 'point_bookvalue',
  Point_CashFlowYield = 'point_cashflowyield',
  Point_CurrentYield = 'point_currentyield',
  Point_EPRatio = 'point_epratio',
  Point_EarningsPerShare = 'point_earningspershare',
  Point_EffectiveD2 = 'point_effectived2',
  Point_EffectiveD3 = 'point_effectived3',
  Point_DurContributionPct = 'point_durcontributionpct',
  Point_DurContributionYrs = 'point_durcontributionyrs',
  Point_EffectiveSpreadDuration = 'point_effectivespreadduration',
  Point_SpreadDurContributionPct = 'point_spreaddurcontributionpct',
  Point_SpreadDurContributionYrs = 'point_spreaddurcontributionyrs',
  Point_GainLoss = 'point_gainloss',
  Point_MacaulayDuration = 'point_macaulayduration',
  Point_MarketCap = 'point_marketcap',
  Point_MarketCapLog = 'point_marketcaplog',
  Point_MarketValue = 'point_marketvalue',
  Point_MarketValuePar = 'point_marketvaluepar',
  Point_ModifiedDuration = 'point_modifiedduration',
  Point_Momentum = 'point_momentum',
  Point_MoodyQuality = 'point_moodyquality',
  Point_NotionalValue = 'point_notionalvalue',
  Point_OAS = 'point_oas',
  Point_PBRatio = 'point_pbratio',
  Point_PERatio = 'point_peratio',
  Point_PctFaceMarketValue = 'point_pctfacemarketvalue',
  Point_PctMarketValue = 'point_pctmarketvalue',
  Point_Price = 'point_price',
  Point_SPQuality = 'point_spquality',
  Point_SecurityCount = 'point_securitycount',
  Point_TotalAccruedInterest = 'point_totalaccruedinterest',
  Point_TrailingEPS = 'point_trailingeps',
  Point_Volatility = 'point_volatility',
  Point_YearsToWorst = 'point_yearstoworst',
  // Attribution cards
  Return_Portfolio = 'point_return_portfolio',
  Return_Benchmark = 'point_return_benchmark',
  Return_Active = 'point_return_active',
  Chart_DailyReturn = 'chart_daily_return',
  Chart_PortfolioReturn = 'chart_portfolio_return',
  Chart_BenchmarkReturn = 'chart_benchmark_return',
  Chart_ActiveReturn = 'chart_active_return',
  Chart_FactorAttribution = 'chart_factor_attribution',
  Table_Holdings = 'table_holdings',
  Table_HoldingsTopBottom = 'table_holdings_top_bottom',
  Chart_HoldingsBubble = 'chart_holdings_bubble',
}

const PORT_ITEM_PREFIX = 'porttotalitem'
export enum RAReportDataSource {
  FactorLens = 'factorLens', // Factor Lens
  FactorContrib = 'factorContrib', // Less Detailed Factor Lens
  TopBottomSecPortfolio = 'endContribPortfolio', // Top/Bottom Securities
  RiskMetricsSummary = 'riskMetricsSummary',
  RiskOneYearHistory = 'riskOneYearHistory',
  HoldingsSecurities = 'securityHoldings',
  HoldingsSecurityDetails = 'holdingsSecurityDetails',
  // Begin PortTotalItems.
  PortTotalItems = PORT_ITEM_PREFIX + 's', // Every Known Item
  PortItemDV01 = `${PORT_ITEM_PREFIX}.${ReportItem.DV01}`,
  PortItemConvexity = `${PORT_ITEM_PREFIX}.${ReportItem.Convexity}`,
  PortItemEffectiveDuration = `${PORT_ITEM_PREFIX}.${ReportItem.EffectiveDuration}`,
  PortItemYieldToMaturity = `${PORT_ITEM_PREFIX}.${ReportItem.YieldToMaturity}`,
  PortItemSpreadDuration = `${PORT_ITEM_PREFIX}.${ReportItem.SpreadDuration}`,
  PortItemYearsToMaturity = `${PORT_ITEM_PREFIX}.${ReportItem.YearsToMaturity}`,
  PortItemYieldToWorst = `${PORT_ITEM_PREFIX}.${ReportItem.YieldToWorst}`,
  PortItemCouponRate = `${PORT_ITEM_PREFIX}.${ReportItem.CouponRate}`,
  PortItemDividendYield = `${PORT_ITEM_PREFIX}.${ReportItem.DividendYield}`,
  PortItemAverageLife = `${PORT_ITEM_PREFIX}.${ReportItem.AverageLife}`,
  PortItemBeta = `${PORT_ITEM_PREFIX}.${ReportItem.Beta}`,
  PortItemBookToPrice = `${PORT_ITEM_PREFIX}.${ReportItem.BookToPrice}`,
  PortItemBookValue = `${PORT_ITEM_PREFIX}.${ReportItem.BookValue}`,
  PortItemCashFlowYield = `${PORT_ITEM_PREFIX}.${ReportItem.CashFlowYield}`,
  PortItemCurrentYield = `${PORT_ITEM_PREFIX}.${ReportItem.CurrentYield}`,
  PortItemEPRatio = `${PORT_ITEM_PREFIX}.${ReportItem.EPRatio}`,
  PortItemEarningsPerShare = `${PORT_ITEM_PREFIX}.${ReportItem.EarningsPerShare}`,
  PortItemEffectiveD2 = `${PORT_ITEM_PREFIX}.${ReportItem.EffectiveD2}`,
  PortItemEffectiveD3 = `${PORT_ITEM_PREFIX}.${ReportItem.EffectiveD3}`,
  PortItemDurContributionPct = `${PORT_ITEM_PREFIX}.${ReportItem.DurContributionPct}`,
  PortItemDurContributionYrs = `${PORT_ITEM_PREFIX}.${ReportItem.DurContributionYrs}`,
  PortItemEffectiveSpreadDuration = `${PORT_ITEM_PREFIX}.${ReportItem.EffectiveSpreadDuration}`,
  PortItemSpreadDurContributionPct = `${PORT_ITEM_PREFIX}.${ReportItem.SpreadDurContributionPct}`,
  PortItemSpreadDurContributionYrs = `${PORT_ITEM_PREFIX}.${ReportItem.SpreadDurContributionYrs}`,
  PortItemGainLoss = `${PORT_ITEM_PREFIX}.${ReportItem.GainLoss}`,
  PortItemMacaulayDuration = `${PORT_ITEM_PREFIX}.${ReportItem.MacaulayDuration}`,
  PortItemMarketCap = `${PORT_ITEM_PREFIX}.${ReportItem.MarketCap}`,
  PortItemMarketCapLog = `${PORT_ITEM_PREFIX}.${ReportItem.MarketCapLog}`,
  PortItemMarketValue = `${PORT_ITEM_PREFIX}.${ReportItem.MarketValue}`,
  PortItemMarketValuePar = `${PORT_ITEM_PREFIX}.${ReportItem.MarketValuePar}`,
  PortItemModifiedDuration = `${PORT_ITEM_PREFIX}.${ReportItem.ModifiedDuration}`,
  PortItemMomentum = `${PORT_ITEM_PREFIX}.${ReportItem.Momentum}`,
  PortItemMoodyQuality = `${PORT_ITEM_PREFIX}.${ReportItem.MoodyQuality}`,
  PortItemNotionalValue = `${PORT_ITEM_PREFIX}.${ReportItem.NotionalValue}`,
  PortItemOAS = `${PORT_ITEM_PREFIX}.${ReportItem.OAS}`,
  PortItemPBRatio = `${PORT_ITEM_PREFIX}.${ReportItem.PBRatio}`,
  PortItemPERatio = `${PORT_ITEM_PREFIX}.${ReportItem.PERatio}`,
  PortItemPctFaceMarketValue = `${PORT_ITEM_PREFIX}.${ReportItem.PctFaceMarketValue}`,
  PortItemPctMarketValue = `${PORT_ITEM_PREFIX}.${ReportItem.PctMarketValue}`,
  PortItemPrice = `${PORT_ITEM_PREFIX}.${ReportItem.Price}`,
  PortItemSPQuality = `${PORT_ITEM_PREFIX}.${ReportItem.SPQuality}`,
  PortItemSecurityCount = `${PORT_ITEM_PREFIX}.${ReportItem.SecurityCount}`,
  PortItemTotalAccruedInterest = `${PORT_ITEM_PREFIX}.${ReportItem.BaseTotalAccruedInterest}`,
  PortItemTrailingEPS = `${PORT_ITEM_PREFIX}.${ReportItem.TrailingEPS}`,
  PortItemVolatility = `${PORT_ITEM_PREFIX}.${ReportItem.Volatility}`,
  PortItemYearsToWorst = `${PORT_ITEM_PREFIX}.${ReportItem.YearsToWorst}`,
  // End PortTotalItems
  // Attribution Items
  // TODO: Split Risk data sources and Attribution data sources into different enums. Use a Union type to join them for consumers.
  TotalReturns = "totalReturns",
  AttributionDurations = "attrDurations",
  DailySummaries = "dailySummaries",
  FactorContributionFreq = "factorContributionFreq",
  FactorContributionTotal = "factorContributionTotal",
  SecurityContribution = "securityContribution"
}
